import React, { useEffect, useRef } from "react";

const Chatbot = () => {
  return (
    // Under Construction
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        overflow: "hidden",
      }}
    >
      {/* <iframe src="http://192.168.2.16:3000/" width="100%" height="100%" frameborder="0"></iframe> */}

      {/* Service 1 */}
      {/* <iframe src="https://chatbot-frontend-silk.vercel.app/" width="100%" height="100%" frameborder="0"></iframe> */}

      {/* Service 2 */}
      <iframe src="https://chatbok.azurewebsites.net/" width="100%" height="100%" frameborder="0"></iframe>
    </div>
  );
};

export default Chatbot;
